import React from "react";
import "./about.css";

const facts = [
  { label: "Based in", value: "Bengaluru, India" },
  { label: "Education", value: "MSc Physics, IIT Bombay" },
  { label: "Focus", value: "AI Agents & Full-Stack" },
];

export default function About() {
  return (
    <section className="section" id="about">
      <div className="section-inner about-inner">
        <h2 className="section-title">About Me</h2>
        <span className="section-title-accent" />

        <p className="about-text">
          I&apos;m an engineer who enjoys turning hard AI problems into reliable
          products. I earned my MSc in Physics from <strong>IIT Bombay</strong>{" "}
          and have since shipped agentic AI systems, real-time voice agents, and
          full-stack apps used by tens of thousands of people. Today I&apos;m a
          Founding Engineer at
          HiRobin, working across realtime models, RAG, and production cloud
          infrastructure.
        </p>

        <div className="about-facts">
          {facts.map((f) => (
            <div className="about-fact" key={f.label}>
              <span className="about-fact-label">{f.label}</span>
              <span className="about-fact-value">{f.value}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
